import { LotacaoEditableTableModel } from 'components/form/editable-table/LotacaoEditableTable'
import {
  AtividadeColetivaGruposVisualizarQuery,
  AtividadeColetivaGrupoTableQuery,
  PageParams,
  TipoGrupoParticipanteAtividadeColetivaEnum,
} from 'graphql/types.generated'

import { EquipeSelectModel, UnidadeSaudeSelectModel } from '../../../components/form'
import { CidadaoEditableTableModel } from './CidadaoEditableTable'

export interface AtividadeColetivaGruposFilterPopperFormModel {
  unidadesSaude?: UnidadeSaudeSelectModel[]
  equipes?: EquipeSelectModel[]
  tipoGrupo?: TipoGrupoParticipanteAtividadeColetivaEnum
  showOnlyInativos?: boolean
}

export type AtividadeColetivaGruposFilterFormModel = AtividadeColetivaGruposFilterPopperFormModel & {
  nomeGrupo?: string
  isSomenteRegistrosProprios: boolean
  pageParams?: PageParams
}

export interface AtividadeColetivaGruposFormModel {
  id?: ID
  nome: string
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  lotacoesEnvolvidas?: LotacaoEditableTableModel[]
  cidadaosParticipantes?: CidadaoEditableTableModel[]
}

export interface AtividadeColetivaGruposTableModel {
  id: ID
  nome: string
  tipoGrupo: string
  quantidadeCidadaosParticipantes: number
  unidadeSaude: string
  equipesEnvolvidas: string
  ativo: boolean
}

export type AtividadeColetivaGruposContentType = AtividadeColetivaGrupoTableQuery['gruposParticipantesAtividadeColetiva']['content'][0]

export interface AtividadeColetivaGruposInputModel {
  isAtivo: boolean
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  equipesIds: string[]
  unidadesSaudeIds: string[]
  nomeGrupo: string
  isSomenteMeusGrupos: boolean
  pageParams: PageParams
}

export const atividadeColetivaTipoGrupoRecord: Record<TipoGrupoParticipanteAtividadeColetivaEnum, string> = {
  REUNIAO: 'Reunião',
  ATIVIDADE_EM_SAUDE: 'Atividade em saúde',
}

export type AtividadeColetivaGruposModel = AtividadeColetivaGruposVisualizarQuery['grupoParticipanteAtividadeColetiva']
